import React, { useCallback, useState } from 'react';
import { useDealByIdQuery } from 'api';
import { RejectModal } from './RejectModal';
import { useParams } from 'react-router-dom';
import { useRejectDeal } from './useRejectDeal';
import { OriginalEmailModal } from 'components';
import { DealRejectionReasons } from 'models/Deal';
import { PERMISSIONS } from 'constants/permissions';
import { Button, Col, HasAccess, Row } from 'components';
import { GreenEmailIcon } from 'components/common/icons/GreenEmailIcon';
import styles from '../styles.module.scss';
import { CloseCircleFilled } from '@ant-design/icons';

export const OriginalEmailAndRejection = React.memo(() => {
  const [openEmail, setOpenEmail] = useState(false);
  const { id } = useParams() as { id: string };
  const { data: dealDetails = {} } = useDealByIdQuery({ id });
  const {
    form: rejectForm,
    isModalVisible: isRejectModalVisible,
    showModal: showRejectModal,
    hideModal: hideRejectModal,
    handleSubmit: handleRejectSubmit,
  } = useRejectDeal();

  const onModalStateChange = useCallback(() => {
    setOpenEmail((oState) => !oState);
  }, []);

  if (!dealDetails.emailId) {
    return null;
  }
  return (
    <Row>
      <Col span={24} className={styles.open_email}>
        <Button onClick={onModalStateChange} className={styles.text} type={'link'} icon={<GreenEmailIcon />}>
          Client Original Email
        </Button>
      </Col>
      <HasAccess role={PERMISSIONS.deals.deal.write}>
        {!dealDetails.isFinalStatus && (
          <Col span={24} className={styles.reject_row}>
            <Button
              className={styles.reject_link}
              danger
              type="link"
              size="small"
              onClick={showRejectModal}
              icon={<CloseCircleFilled />}
            >
              Reject Deal
            </Button>
          </Col>
        )}
      </HasAccess>
      <OriginalEmailModal emailId={dealDetails.emailId} isModalOpen={openEmail} onClose={onModalStateChange} />
      <RejectModal
        form={rejectForm}
        open={isRejectModalVisible}
        onSubmit={handleRejectSubmit}
        onCancel={hideRejectModal}
        rejectionReasons={Object.values(DealRejectionReasons)}
      />
    </Row>
  );
});
